// extracted by mini-css-extract-plugin
export default {"container":"styles_container__bGaX4","timer_block":"styles_timer_block__dxTa+","timer":"styles_timer__XBDEI","timer_text":"styles_timer_text__KtmPI","button":"styles_button__Batrp"};